import React, { useEffect, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label, { DisplayLabel } from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Float from "../ui/Float";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { bm_date, drawNote, drawPOSStatus } from "../utils/Utils";

export default function ProcessingDetails(props) {

    const { selected = {}, setSelected = () => { }, items = [], setItems = () => { }, selectedItem = {}, setSelectedItem = () => { } } = props;
    const [data, setData] = useState({});

  
    return (
        <div className="pos-card" style={{"height" : "260px"}}>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'row', gap: "20px" }}>
                <div style={{ flex: "1 1 500px", minWidth: "200px" }}>
                  <Space>
                    <Label>List</Label>
                    <Input edit width={100} value="56.94" />
                     <Label>Net</Label>
                    <Input edit width={100} value="34.16" />
                    <Label>Min</Label>
                    <Input edit width={100} value="" />
                     <Label>BO</Label>
                    <Input edit width={50} value="YES" />
                  </Space>
                </div>

                <div style={{ flex: "1 1 0", minWidth: "200px" }}>
                   
                </div>

                <div style={{ flex: "1 1 0", minWidth: "200px" }}>
                   
                </div>

                <div style={{ flex: "1 1 0", minWidth: "200px" }}>
                    
                </div>
            </div>
           
        </div>
    )
}